// Depends
import { route, group, subGroup, meta } from '@/helpers/routes'

import Index from './index/index'

const accountabilityRoutes = [
  route('index', '/index', Index, meta('Lista de Prestações de Contas', true, 'guest'))
]

export default [
  ...group('/app', [
    ...subGroup('/accountability', accountabilityRoutes)
  ])
]



// WEBPACK FOOTER //
// ./src/app/tenant/accountability/routes.js